import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNil } from 'lodash';
import { Observable } from 'rxjs';
import { SettingsService } from '../app/common/settings.service';

export abstract class ApiBase {
  protected constructor(
    protected http: HttpClient,
    protected baseUrl: string
  ) {}

  protected get<T>(endpoint: string, options = null): Observable<T> {
    if (isNil(options)) {
      return this.http.get<T>(this.getUrl(endpoint));
    } else {
      return this.http.get<T>(this.getUrl(endpoint), options) as Observable<T>;
    }
  }

  protected postContent<K>(
    endpoint: string,
    value: any,
    options = null
  ): Observable<K> {
    if (isNil(options)) {
      return this.http.post(this.getUrl(endpoint), value) as Observable<K>;
    } else {
      return this.http.post(
        this.getUrl(endpoint),
        value,
        options
      ) as Observable<K>;
    }
  }

  protected post<T, K>(
    endpoint: string,
    value: T,
    options = null
  ): Observable<K> {
    if (isNil(options)) {
      return this.http.post(this.getUrl(endpoint), value) as Observable<K>;
    } else {
      return this.http.post(
        this.getUrl(endpoint),
        value,
        options
      ) as Observable<K>;
    }
  }

  protected put<T, K>(
    endpoint: string,
    value: T,
    options = null
  ): Observable<K> {
    if (isNil(options)) {
      return this.http.put<K>(this.getUrl(endpoint), value);
    } else {
      return this.http.put<K>(
        this.getUrl(endpoint),
        value,
        options
      ) as Observable<K>;
    }
  }

  protected delete<T>(endpoint: string, options = null): Observable<T> {
    if (isNil(options)) {
      return this.http.delete<T>(this.getUrl(endpoint));
    } else {
      return this.http.delete<T>(
        this.getUrl(endpoint),
        options
      ) as Observable<T>;
    }
  }

  protected getUrl(path: string): string {
    return `${this.baseUrl}${path}`;
  }
  protected getUserIdHeaders(userId: string): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('UserId', userId);

    return headers;
  }
}

@Injectable({
  providedIn: 'root'
})
@Injectable({
  providedIn: 'root'
})
export abstract class OsmosisApiBase extends ApiBase {
  constructor(
    protected override http: HttpClient,
    settings: SettingsService
  ) {
    super(http, settings.baseUrl);
  }
}

@Injectable({
  providedIn: 'root'
})
export abstract class EventsApiBase extends ApiBase {
  constructor(
    protected override http: HttpClient,
    settings: SettingsService
  ) {
    super(http, settings.baseEventsUrl);
  }
}

@Injectable({
  providedIn: 'root'
})
export abstract class PartnerManagementApiBase extends ApiBase {
  constructor(
    protected override http: HttpClient,
    settings: SettingsService
  ) {
    super(http, settings.basePartnerManagementApiUrl);
  }
}
